import { render, staticRenderFns } from "./PromotionStepGeneralInfo.vue?vue&type=template&id=7cb0b13b&scoped=true&"
import script from "./PromotionStepGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./PromotionStepGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./PromotionStepGeneralInfo.vue?vue&type=style&index=0&id=7cb0b13b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb0b13b",
  null
  
)

export default component.exports